import React from "react";
import {questions} from "./data";
import Banner from "./Banner";



 const Faq = () => {
  return (
  <>
   <Banner.Header>Frequently Asked Questions</Banner.Header>
     <Banner>
      {questions.map((question) => (
        <Banner.Entity key={question.id}>
          <Banner.Question>{question.question}</Banner.Question>
          
          <Banner.Text>
            <img src={question.pic} alt=""/>{question.answer}

       {/* {question.pic.map((icon,index)=> 
      {return (<> <img src={icon} alt=""/> {question.answer[index]}</>)})} */}
          </Banner.Text>
        </Banner.Entity>
      ))}
    </Banner>  
    </>
  );
};

export default Faq;